import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Image } from "@/ui";
import classes from "./styles.module.scss";
import QuickJobSearch from "@/components/QuickJobSearch";
import TileGroup from "@/components/TileGroup";
import { homepage_tiles_helper } from "@/helpers/homepage_tiles_helper";

const defaultImage = {
  url: "https://cdn.sourceflow.co.uk/__gallery/c5f7ea04-c9cf-4e04-ad62-3bdda961af5e",
};

export const HeaderWithJobAndTiles = ({
  className,
  jobTitle,
  img,
  showJobs = true,
  showTiles = true,
  bgColor,
  textColor,
}) => {
  
  const homepageItems = homepage_tiles_helper.fetch();
  const finalImage = img?.url || defaultImage.url;

  return (
    <div>
      <div className={clsx(className, classes.hero, `bg-${bgColor}`, `text-${textColor}`)}>
        {finalImage && (
          <figure className={classes.hero__img}>
            <Image img={finalImage} size="1920x" alt="Hero image" />
          </figure>
        )}

        {showJobs && (
          <div className={classes.hero__content}>
            <Container>
              <Row>
                <Col xs={12}>
                  <QuickJobSearch title={jobTitle} />
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
      {showTiles && <TileGroup items={homepageItems} />}
    </div>
  );
};

export default HeaderWithJobAndTiles;
